import React from 'react';
import ReactDOM from 'react-dom';
import buildResourcePath from '@lib/buildResourcePath'

class TooltipPortal extends React.Component {

    constructor(props) {
        super(props)

        this.el = document.getElementById('tooltip-portal')

        if (this.el === null) {
            this.el = document.createElement('div')
            this.el.setAttribute('id', 'tooltip-portal')
            document.body.appendChild(this.el)
        }

        this.el.setAttribute('class', 'tooltip-portal-content tooltip-style-' + this.props.style)
    }

    componentDidMount() {
        let rect = this.props.rootRef.getBoundingClientRect()
        this.el.style.top = (rect.top + window.pageYOffset) + 'px';
        this.el.style.left = rect.left + 'px';
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el
        )
    }
}

export default class Tooltip extends React.Component {

    state = {
        visible: false
    }

    constructor(props) {
        super(props)
        this.rootRef = React.createRef()
    }

    onMouseEnter = e => {
        this.setState({
            visible: true
        })
    }

    onMouseLeave = e => {
        this.setState({
            visible: false
        })
    }

    render() {
        return (
            <div className={`tooltip tooltip-style-${this.props.style}`} onMouseEnter={this.onMouseEnter}
                 onMouseLeave={this.onMouseLeave} ref={this.rootRef}>
                <div className="tooltip-icon">
                    <img src={this.props.icon}/>
                </div>

                {this.state.visible && (
                    <TooltipPortal style={this.props.style} rootRef={this.rootRef.current}>
                        <div dangerouslySetInnerHTML={{__html: this.props.text}} className="tooltip-text"></div>
                    </TooltipPortal>
                )}
            </div>
        )
    }
}